$( document ).ready(function() {

  var countdownBar = $('.countdown-bar');
  var countdownBarContent = $('.countdown-bar__content');

  // variables
  var countdownPrefix = countdownBar.data('prefix');
  var countdownVar = countdownBar.data('time');
  var countdownSuffix = countdownBar.data('suffix');
  var countdownSkipWeekend = countdownBar.data('skipweekend');

  if (typeof countdown !== 'undefined' && countdownBar.length && countdownVar.length) {

      function countdownTimer() {

        var today = new Date();
        
        var dayOfWeek = today.getDay();
        //console.log(countdownSkipWeekend);

        //var countdownVar = "08:15";
        //var countdownVar = "2020-03-01T14:00";
        var countdownVarStr = countdownVar;

        if (countdownVar.length < 6) {
          // assume only time provided, and see if we need to get todays full date or tomorrows
          var time = countdownVar.split(":");

          if(time.length > 1) {
            // assume array
            if( 
              (
                (time[0] == today.getHours()) && 
                (time[1] <= today.getMinutes()) &&
                (today.getSeconds() >= 0)
              ) ||
              (
                (time[0] == today.getHours()) && 
                (time[1] < today.getMinutes())
              ) ||
              (time[0] < today.getHours()) ||
              (
              	(countdownSkipWeekend == true) &&
                	(
                  		(dayOfWeek == 6) ||
                      	(dayOfWeek == 0)
                	)
              )
            ) {
              // need tomorrow
              //console.log('need tomorrow');

              var tomorrow = new Date();
              //tomorrow.setDate(tomorrow.getDate() + 1);
              
              if (countdownSkipWeekend) {
               // set up test date to compare
                var testDate = new Date();
                testDate.setDate(tomorrow.getDate() + 1);
                var testDay = testDate.getDay();
                
                if (testDay == 6) {
                  // if Sat, add extra 2
                  tomorrow.setDate(tomorrow.getDate() + 3);
                } else if (testDay == 0) {
                  // if Sun, add extra 1
                  tomorrow.setDate(tomorrow.getDate() + 2);
                } else {
                  tomorrow.setDate(tomorrow.getDate() + 1);
                }
              } else {
                tomorrow.setDate(tomorrow.getDate() + 1);
              }
              
              var month = tomorrow.getMonth()+1;
              if (month < 10) { month =  '0' + month };
              
              var day = tomorrow.getDate();
              if (day < 10) { day =  '0' + day };

              countdownVarStr = tomorrow.getFullYear() + '-' + month + '-' + day + 'T' + countdownVar;

            }
            else {
              // need today
              //console.log('need today');
              
              var month = today.getMonth()+1;
              if (month < 10) { month =  '0' + month };
              
              var day = today.getDate();
              if (day < 10) { day =  '0' + day };

              countdownVarStr = today.getFullYear() + '-' + month + '-' + day + 'T' + countdownVar;
              
              //console.log(countdownVarStr);

            }
          }

        }


        var target = new Date(countdownVarStr);
        
        //console.log(target);
        
        if((target - today) > 0) {

          countdownBar.addClass('countdown-bar--active');
          
          var countdownObj = countdown(today, target, countdown.DAYS | countdown.HOURS | countdown.MINUTES);

          if( (countdownObj['days'] < 1) && (countdownObj['hours'] < 1) ) {
            countdownObj = countdown(today, target, countdown.HOURS | countdown.MINUTES | countdown.SECONDS)
          }

          var countdownStr = countdownObj.toString();

          if (countdownBar.length) {
            countdownBarContent.html(
              '<span>' + countdownPrefix + '</span> ' +
              countdownStr +
              ' <span>' + countdownSuffix + '</span>'
            );
          }
          
        } else {
          countdownBar.removeClass('countdown-bar--active');
        }

        var countdownRepeat = setTimeout(countdownTimer, 1000);

      }

    countdownTimer();
  }
  
});